var React = require('react');

function Share (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M352 320c-28.6 0-54.2 12.5-71.8 32.3l-95.5-59.7c9.6-23.4 9.7-49.8 0-73.2l95.5-59.7c17.6 19.8 43.2 32.3 71.8 32.3 53 0 96-43 96-96S405 0 352 0s-96 43-96 96c0 13 2.6 25.3 7.2 36.6l-95.5 59.7C150.2 172.5 124.6 160 96 160c-53 0-96 43-96 96s43 96 96 96c28.6 0 54.2-12.5 71.8-32.3l95.5 59.7c-4.7 11.3-7.2 23.6-7.2 36.6 0 53 43 96 96 96s96-43 96-96c-.1-53-43.1-96-96.1-96zm0-288c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm256 160c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z","className":""}));
}

Share.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","data-prefix":"fal","data-icon":"share-alt","role":"img","viewBox":"0 0 448 512","className":"svg-inline--fa fa-share-alt fa-w-14 fa-9x"};

module.exports = Share;

Share.default = Share;
